/* Home-only layouts. Section surfaces and spacing stay in the shared utilities. */

/* The analyses' arrows: from 64rem the cards become a list (AnalysesList's WIDE), with
   nothing to scroll. */
@media (min-width: 64rem) {
  .analysesArrows {
    display: none;
  }
}

/* Latest: one lead item beside two compact ones, instead of three equal cards. */
.latest {
  display: grid;
  gap: var(--sp-8);
}
.latestRest {
  display: grid;
  align-content: start;
  gap: var(--sp-6);
}
.latestRest > * + * {
  padding-top: var(--sp-6);
  border-top: 1px solid var(--border);
}
@media (min-width: 64rem) {
  .latest {
    grid-template-columns: minmax(0, 1.45fr) minmax(0, 1fr);
    gap: var(--sp-12);
  }
}
